import I18N_FORMAT_MAP from '@rover/constants/src/i18n/i18nFormatMap.constants';
import { DEFAULT_LANG } from '@rover/constants/src/i18n/language';

const getLocalizedFormatContextless = (format: string, lang?: string): string => {
  const langs = I18N_FORMAT_MAP[(lang || '').toLowerCase()] || I18N_FORMAT_MAP[DEFAULT_LANG];
  return langs[format] || I18N_FORMAT_MAP[DEFAULT_LANG][format] || format;
};

export default getLocalizedFormatContextless;
